module.exports = __webpack_public_path__ + "img/singdir.12bb723d.png";